module.exports = __webpack_public_path__ + "workspace/static/img/download-center-beta-one.73ff409.png";